import React from 'react';
import { Button } from './Button/Button';


export function Pagination({ current, total, onPageChange }) {
  if (total <= 1) return null;

  const pages = [];
  for (let i = 1; i <= total; i++) {
    if (
      i === 1 ||
      i === total ||
      Math.abs(i - current) <= 1 ||
      (current <= 3 && i <= 4) ||
      (current >= total - 2 && i >= total - 3)
    ) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '…') {
      pages.push('…');
    }
  }

  return (
    <div className="flex items-center space-x-2 mt-4 flex-wrap">
      {pages.map((p, idx) =>
        p === '…' ? (
          <span key={idx} className="px-2 text-[var(--text-secondary)]">…</span>
        ) : (
          <Button
            key={p}
            variant={p === current ? 'outline' : 'primary'}
            onClick={() => onPageChange(p)}
            className="w-10 text-center"
          >
            {p}
          </Button>
        )
      )}
    </div>
  );
}
